// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_71-0";